import React from 'react';
import PropTypes from 'prop-types';

import CoreStreamer from '@spp/ui-streamer';
import plussIndicatorTheme from '../../../themes/ui-streamer/styles/pluss-indicator.scss';

const Streamer = (props) => {
    const { subtype = '' } = props;

    if (subtype === 'pluss-indicator') {
        return (
            <a href="https://www.vg.no/pluss">
                <CoreStreamer theme={plussIndicatorTheme} {...props} />
            </a>
        );
    }

    return null;
};

Streamer.defaultProps = {
    subtype: '',
};

Streamer.propTypes = {
    subtype: PropTypes.string,
};

export default Streamer;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Streamer.js
 **/